<template>
	<v-dialog v-model="$store.state.loading" hide-overlay persistent width="200">
		<v-card >
			<v-card-text >
				Loading
				<v-progress-linear indeterminate class="mb-0"> </v-progress-linear>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name:'LoadingDialog'
	}
</script>
